import React, { useState } from "react";
import Section from "./layouts/Section";
import { SiteWide } from "./customComponents";
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";

import { userSelect, allRemoteSettingsSelect } from '../redux/selectors/index';
import { notify } from '../utility/Helper1';

import copy from 'copy-to-clipboard';
import QRCode from "react-qr-code";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

// Modern UI Icons
import {
    Share2,
    Copy,
    QrCode,
    Gift,
    Award,
    CheckCircle,
    AlertCircle,
    Sparkles
} from 'lucide-react';

function RefLink() {
    const userData = useSelector(userSelect);
    const site_settings = useSelector(allRemoteSettingsSelect);
    const navigate = useNavigate();

    const [copiedStates, setCopiedStates] = useState({ refId: false, link: false });

    const copyRefLink = () => {
        notify('Referral Link Copied', 1);
        setCopiedStates(prev => ({ ...prev, link: true }));
        setTimeout(() => {
            setCopiedStates(prev => ({ ...prev, link: false }));
        }, 2000);
    };

    const copyToClipboard = (text, type) => {
        copy(text);
        setCopiedStates(prev => ({ ...prev, [type]: true }));
        setTimeout(() => {
            setCopiedStates(prev => ({ ...prev, [type]: false }));
        }, 2000);
        notify('Copied to clipboard!', 1);
    };

    const ref_earning_1 = site_settings?.plans?.[0]?.childs?.[0]?.ref_earning_1 || '10';
    const ref_earning_2 = site_settings?.plans?.[0]?.childs?.[0]?.ref_earning_2 || '5';
    const ref_earning_3 = site_settings?.plans?.[0]?.childs?.[0]?.ref_earning_3 || '2';

    const levelTableDesc = [
        { id: 1, percent: `${ref_earning_1}%`, desc: 'Direct invitee' },
        { id: 2, percent: `${ref_earning_2}%`, desc: 'LV1 invitee' },
        { id: 3, percent: `${ref_earning_3}%`, desc: 'LV2 invitee' },
    ];

    const myRefLink = site_settings?.site_settings?.site_url + '/#/signup?ref=' + userData?.myrefid;

    return (
        <SiteWide id="main" title="Invite Your Friends">
            <Section hideHeader={true} overlayText="" loading={false} title="Invite">
                <div className="flex flex-col gap-5 pb-8" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                    
                    {/* Header bar with Back Button */}
                    <div style={{ display: "flex", alignItems: "center", gap: 14, margin: "4px 0" }}>
                        <button
                            onClick={() => navigate(-1)}
                            style={{
                                width: 36, height: 36, borderRadius: "50%",
                                background: "rgba(59,130,246,0.06)", border: "1px solid rgba(59,130,246,0.12)",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                cursor: "pointer", outline: "none"
                            }}
                        >
                            <ArrowBackIosNewIcon style={{ color: "#2563eb", fontSize: 13 }} />
                        </button>
                        <div>
                            <p style={{ color: "var(--text-muted)", fontSize: 10, margin: 0, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em" }}>Partner Program</p>
                            <h2 style={{ color: "var(--text-main)", fontSize: 18, fontWeight: 700, fontFamily: "'Syne',sans-serif", margin: 0 }}>
                                Invite & Earn
                            </h2>
                        </div>
                    </div>

                    {/* Premium Glassmorphic Referral Banner */}
                    <div className="rounded-2xl p-5 relative overflow-hidden" style={{ 
                        background: "linear-gradient(135deg, #1e3a8a 0%, #2563eb 50%, #3b82f6 100%)", 
                        border: "1px solid rgba(96,165,250,0.15)", 
                        boxShadow: "0 10px 25px -5px rgba(37,99,235,0.3)" 
                    }}>
                        <div className="absolute top-0 right-0 opacity-15" style={{ width: 140, height: 140, background: "radial-gradient(circle, #93c5fd, transparent)", borderRadius: "50%", transform: "translate(30px,-30px)" }} />
                        <div className="absolute -bottom-10 -left-10 opacity-10" style={{ width: 160, height: 160, background: "radial-gradient(circle, #3b82f6, transparent)", borderRadius: "50%" }} />
                        
                        <div className="relative z-10">
                            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-white mb-3" style={{ background: "rgba(255, 255, 255, 0.16)", backdropFilter: "blur(4px)", border: "1px solid rgba(255, 255, 255, 0.25)" }}>
                                <Sparkles size={11} className="text-yellow-300 animate-pulse" />
                                <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: "0.08em" }}>AFFILIATE NETWORK</span>
                            </div>
                            
                            <h3 style={{ color: "#ffffff", fontSize: 22, fontWeight: 800, fontFamily: "'Syne',sans-serif", lineHeight: 1.2, margin: "0 0 8px 0" }}>
                                Share the AI Experience
                            </h3>
                            <p style={{ color: "rgba(255, 255, 255, 0.88)", fontSize: 12, lineHeight: 1.5, margin: 0, maxWidth: "90%" }}>
                                Invite friends to register and unlock up to 3 tiers of passive interest commissions on all daily active chat earnings in your downline.
                            </p>
                        </div>
                    </div>

                    {/* Toolkit & Sharing Area */}
                    <div className="rounded-2xl p-5" style={{ 
                        background: "var(--card-bg, #ffffff)", 
                        border: "1px solid var(--border-color, rgba(59,130,246,0.08))", 
                        boxShadow: "var(--card-shadow, 0 4px 18px rgba(59,130,246,0.04))" 
                    }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
                            <QrCode size={18} className="text-blue-500" />
                            <p style={{ color: "var(--text-main)", fontSize: 13, fontWeight: 700, fontFamily: "'Syne',sans-serif", margin: 0 }}>Your Share Toolkit</p>
                        </div>

                        {/* QR Code Container */}
                        <div className="flex flex-col items-center justify-center p-4 mb-5 rounded-xl" style={{ background: "var(--neutral-100)", border: "1px solid var(--border-color)" }}>
                            <div className="p-4 rounded-xl shadow-sm border transform hover:scale-102 transition-all duration-300" style={{ "--qr-bg": "#ffffff", background: "var(--qr-bg)", borderColor: "var(--border-color)", cursor: "pointer" }}>
                                <QRCode value={myRefLink} size={130} />
                            </div>
                            <span style={{ color: "var(--text-muted)", fontSize: 10, marginTop: 10, fontWeight: 500, textAlign: "center" }}>
                                Let friends scan this QR to signup instantly
                            </span>
                        </div>

                        {/* Referral ID Field */}
                        <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 14 }}>
                            <label style={{ color: "var(--text-muted)", fontSize: 11, fontWeight: 600 }}>Your Unique Referral ID</label>
                            <div style={{ 
                                display: "flex", 
                                alignItems: "center", 
                                justifyContent: "space-between", 
                                background: "var(--neutral-100)", 
                                border: "1px solid var(--border-color)", 
                                borderRadius: 12, 
                                padding: "10px 14px"
                            }}>
                                <span style={{ color: "var(--text-main)", fontWeight: 700, fontSize: 14, fontFamily: "'Syne', sans-serif", letterSpacing: "0.04em" }}>{userData?.myrefid}</span>
                                <button
                                    onClick={() => copyToClipboard(userData?.myrefid, 'refId')}
                                    style={{
                                        border: "none",
                                        background: "transparent",
                                        color: copiedStates.refId ? "#22c55e" : "#2563eb",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 4,
                                        fontSize: 12,
                                        fontWeight: 600,
                                        padding: 0
                                    }}
                                >
                                    {copiedStates.refId ? <CheckCircle size={14} /> : <Copy size={14} />}
                                    <span>{copiedStates.refId ? "Copied" : "Copy"}</span>
                                </button>
                            </div>
                        </div>

                        {/* Referral Link Field */}
                        <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 4 }}>
                            <label style={{ color: "var(--text-muted)", fontSize: 11, fontWeight: 600 }}>Referral Invitation Link</label>
                            <div style={{ 
                                display: "flex", 
                                alignItems: "center", 
                                background: "var(--neutral-100)", 
                                border: "1px solid var(--border-color)", 
                                borderRadius: 12, 
                                padding: "6px 6px 6px 14px"
                            }}>
                                <span className="truncate" style={{ color: "var(--text-muted)", fontSize: 11, flex: 1, marginRight: 8, fontFamily: "monospace" }}>{myRefLink}</span>
                                <button
                                    onClick={() => { copy(myRefLink); copyRefLink(); }}
                                    style={{
                                        border: "none",
                                        background: "linear-gradient(135deg,#3b82f6,#2563eb)",
                                        color: "#ffffff",
                                        borderRadius: 8,
                                        padding: "8px 14px",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 5,
                                        fontSize: 11,
                                        fontWeight: 600,
                                        boxShadow: "0 2px 6px rgba(37,99,235,0.15)"
                                    }}
                                >
                                    {copiedStates.link ? <CheckCircle size={12} /> : <Share2 size={12} />}
                                    <span>{copiedStates.link ? "Copied" : "Copy Link"}</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Rates & Level Rewards Structure */}
                    <div className="rounded-2xl p-5" style={{ 
                        background: "var(--card-bg, #ffffff)", 
                        border: "1px solid var(--border-color, rgba(59,130,246,0.08))", 
                        boxShadow: "var(--card-shadow, 0 4px 18px rgba(59,130,246,0.04))" 
                    }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
                            <Gift size={18} className="text-purple-500" />
                            <p style={{ color: "var(--text-main)", fontSize: 13, fontWeight: 700, fontFamily: "'Syne',sans-serif", margin: 0 }}>Commission Structure</p>
                        </div>

                        {/* Info Note */}
                        <div style={{ 
                            background: "var(--alert-warning-bg, rgba(245, 158, 11, 0.04))", 
                            border: "1px solid var(--alert-warning-border, rgba(245, 158, 11, 0.12))", 
                            borderRadius: 12, 
                            padding: 12, 
                            display: "flex", 
                            alignItems: "flex-start", 
                            gap: 10,
                            marginBottom: 16
                        }}>
                            <AlertCircle size={15} className="text-amber-500 shrink-0" style={{ marginTop: 1 }} />
                            <p style={{ color: "var(--alert-warning-text, #78350f)", fontSize: 11, lineHeight: 1.45, margin: 0, fontWeight: 500 }}>
                                <strong>Active Rebating:</strong> Commissions are calculated automatically on every successful chat session reward earned by your downline team members.
                            </p>
                        </div>

                        {/* Level cards strip */}
                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                            {levelTableDesc.map((lvl) => {
                                const levelIconColors = [
                                    { text: "#22c55e", bg: "rgba(34, 197, 94, 0.04)", border: "rgba(34, 197, 94, 0.08)" },
                                    { text: "#3b82f6", bg: "rgba(59, 130, 246, 0.04)", border: "rgba(59, 130, 246, 0.08)" },
                                    { text: "#a855f7", bg: "rgba(168, 85, 247, 0.04)", border: "rgba(168, 85, 247, 0.08)" }
                                ];
                                const styleTheme = levelIconColors[lvl.id - 1] || levelIconColors[0];

                                return (
                                    <div 
                                        key={lvl.id}
                                        className="transition-all duration-200 hover:-translate-x-1"
                                        style={{ 
                                            background: styleTheme.bg,
                                            border: `1px solid ${styleTheme.border}`,
                                            borderRadius: 14,
                                            padding: "12px 16px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between"
                                        }}
                                    >
                                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                                            <div style={{ 
                                                width: 38, 
                                                height: 38, 
                                                borderRadius: 10, 
                                                background: "var(--card-bg, #ffffff)", 
                                                border: `1px solid ${styleTheme.border}`, 
                                                display: "flex", 
                                                alignItems: "center", 
                                                justifyContent: "center",
                                                color: styleTheme.text
                                            }}>
                                                <Award size={18} />
                                            </div>
                                            <div>
                                                <p style={{ color: "var(--text-main)", fontSize: 13, fontWeight: 700, fontFamily: "'Syne', sans-serif", margin: 0 }}>Tier {lvl.id}</p>
                                                <p style={{ color: "var(--text-muted)", fontSize: 10, margin: 0, fontWeight: 500 }}>{lvl.desc}</p>
                                            </div>
                                        </div>
                                        <div style={{ textAlign: "right" }}>
                                            <span style={{ color: styleTheme.text, fontSize: 18, fontWeight: 800, fontFamily: "'Syne', sans-serif" }}>
                                                {lvl.percent}
                                            </span>
                                            <p style={{ color: "var(--text-muted)", fontSize: 8, margin: 0, fontWeight: 600, textTransform: "uppercase" }}>commission</p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </Section>
        </SiteWide>
    );
}

export default RefLink;